import { SEARCH_CONTAINER_HEIGHT } from '@features/customers/constants/search.constants';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useSingleCustomerContainerStyles = makeStyles((theme: Theme) => ({
	root: {
		display: 'flex',
		flexFlow: 'row wrap',
		marginLeft: 25,
		[theme.breakpoints.down('lg')]: {
			marginLeft: 18,
		},
	},
	loadingContainer: {
		alignItems: 'center',
		display: 'flex',
		height: 'auto',
		justifyContent: 'center',
		minHeight: `calc(100vh - ${SEARCH_CONTAINER_HEIGHT})`,
		width: '100%',
	},
	leftContainer: {
		maxHeight: `calc(100vh - ${SEARCH_CONTAINER_HEIGHT})`,
		paddingBottom: 8,
		scrollbarColor: '#c7c7c7 #E9E9E9',
		scrollbarWidth: 'thin',
		overflowX: 'hidden',
		overflowY: 'auto',
		paddingRight: '8px',
		'&::-webkit-scrollbar': {
			width: 6,
		},
		'&::-webkit-scrollbar-track': {
			backgroundColor: '#E9E9E9',
			borderRadius: 7,
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#c7c7c7',
			borderRadius: 7,
		},
	},
}));

export default useSingleCustomerContainerStyles;
